var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRussiaOkhotaFld1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 40,
    width: 40,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.18 36.337H15.99L36 4C18.093 5.323 4 19.289 4 36.337 4 51.824 15.63 64.764 31.18 68V36.337ZM40.82 4v31.664h15.19L36 68c17.907-1.323 32-15.289 32-32.336C68 20.176 56.37 7.235 40.82 4Z",
    fill: "#CF3B2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRussiaOkhotaFld1);
export default __webpack_public_path__ + "static/media/russia_okhota_fld_1.321856bdfefe11367659ba293674da4e.svg";
export { ForwardRef as ReactComponent };